app.service('csrfToken', function (modal, loading) {
	let csrf_token;

	function get(callback) {
		csrf_token = $('meta[name=_csrf]').attr('content');
		if (csrf_token) {
			callback(csrf_token);
		} else {
			refresh(callback);
		}
	}

	function refresh(callback) {
		loading.start();
		$.ajax({
			url: '/refreshCsrf.ltr',
			type: 'GET',
			success: function (newToken) {
				csrf_token = newToken;
				$("meta[name='_csrf']").attr("content", csrf_token);
				loading.stop();
				callback(csrf_token);
			},
			error: function () {
				loading.stop();
				modal.alert('Błąd pobierania informacji o CSRF');
			}
		});
	}


	return {
		get,
		refresh
	};
});
